import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProcurementQueueTicket } from '@cots/purchasing/resources/procurement-ticket';
import { Vendor } from '@cots/supplier/resources/vendor';

@Component({
  selector: 'procurement-quick-po',
  templateUrl: './procurement-quick-po.component.html',
  styleUrls: ['./procurement-quick-po.component.less']
})
export class ProcurementQuickPoComponent implements OnInit {

  public readonly item: ProcurementQueueTicket = inject(MAT_DIALOG_DATA);
  public vendor: Vendor = null;
  public qty: number = 0;
  public useExistingQuote = false;

  constructor() { }

  ngOnInit(): void {
    this.useExistingQuote = !!this.item.purchasingSheetItem?.materialBid;
    this.qty = this.getUnassignedQty(this.item);
  }
  
  public getTypeId(): string {
    return (this.item.material && this.item.material.materialGroupId) || this.item.stationId || 'purchased';
  }

  public getTypeName(): string {
    return (this.item.material && this.item.material.materialGroup.groupName) || (this.item.station && this.item.station.name) || 'Hardware';
  }
  
  public getItemName(item: ProcurementQueueTicket) {
    if (item.material) return item.material.materialName;
    else if (item.purchasedItem) return item.purchasedItem.description;
    // TODO name other steps
    else if (item.outsideProcessDescription) return `${item.outsideProcessDescription.steps[0]?.station.name} for ${item.outsideProcessDescription.product.partNumber} Rev. ${item.outsideProcessDescription.product.revision}`;
    else if (item.station) return `${item.station.name}`;
    else if (item.paint) return `${item.paint}`;
    else return "Unknown Item";
  }

  public getSourceTicketName(item: ProcurementQueueTicket) {
    if (item.workOrder) return `WO #${item.workOrder.workOrderNumber}`;
    else if (item.estimate) return item.estimate.quoteNumber ?? item.estimate.orderNumber;
    else if (item.purchaseOrder) return item.purchaseOrder.purchaseOrderNumber;
    else return ""
  }

  public convertItemForChip(item: ProcurementQueueTicket) {
    if (item.outsideProcessDescription) item.station = item.outsideProcessDescription.steps?.[0]?.station;
    return item;
  }
  
  public getTotalAssignmentQty(item: ProcurementQueueTicket) {
    if (!item.purchasingSheetItem) return 0;
    return item.purchasingSheetItem.assignments.reduce((acc, a) => acc + a.qtyAssigned, 0);
  }

  public getUnassignedQty(item: ProcurementQueueTicket) {
    return item.quantity - this.getTotalAssignmentQty(item);
  }
  
  public get isValid() {
    return this.qty > 0 && this.qty <= this.getUnassignedQty(this.item) &&
    ((this.useExistingQuote && this.item.purchasingSheetItem.materialBid) || this.vendor );
  }

  public get output() {
    return {
      vendor: this.vendor,
      qty: this.qty,
      useExistingQuote: this.useExistingQuote,
    }
  }
  

}
